<template>
  <NuxtLayout name="default">
    <div
      class="page_error"
      :class="{ [`status_${error?.statusCode}`]: error?.statusCode }"
    >
      <div class="container_error">
        <template v-if="error?.statusCode === 210">
          <i18n-t keypath="errorPage_2" tag="h1" class="font_title">
            <template #hellomapleEm>
              <em class="font_hm">{{ $t('HelloMaple') }}</em>
            </template>
            <template #br><br /></template>
            <template #icon>
              <atoms-c-image
                class="img_yeti_web"
                file-name="error-yeti-web-play"
                :density="3"
              />
            </template>
            <template #enjoyPC>
              <h1 class="font_title">{{ $t('errorPage_3') }}</h1>
            </template>
          </i18n-t>
        </template>
        <template v-else>
          <atoms-c-image
            class="img_block img_block_1"
            width="160"
            height="63"
            file-name="block-cloud"
            :density="3"
          />
          <atoms-c-image
            class="img_block img_block_2"
            width="221"
            height="113"
            file-name="block-cloud-2"
            :density="3"
          />
          <atoms-c-image class="img_yeti" file-name="error-yeti" :density="3" />
        </template>
        <div class="txt_error">
          <template v-if="error?.statusCode === 404">
            {{ $t('errorPage_4') }}
            <br />
            {{ $t('errorPage_5') }}
          </template>
          <template v-else-if="error?.statusCode === 210">
            {{ $t('errorPage_6') }}
            <br />
            {{ $t('errorPage_7') }}
          </template>
          <template v-else>
            {{ $t('serverError_37') }}
            <br />
            {{ $t('serverError_38') }}
          </template>
        </div>
        <atoms-border-button
          :text="$t('errorPage_8')"
          append-icon="chevron_right_rouned"
          class="btn_main"
          @click="router.push(localePath({ name: 'index' }))"
        ></atoms-border-button>
      </div>
    </div>
  </NuxtLayout>
  <modules-urgent-banner />
</template>
<script setup lang="ts">
const i18nHead = useLocaleHead()

useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang
  }
}))
const error = useError()
const router = useRouter()
const localePath = useLocalePath()
</script>
<style scoped lang="scss">
.page_error {
  overflow: hidden;
  background-color: $bg-l-blue1;
  &.status_210 {
    background-color: #c2f4ff;
    .img_yeti_web {
      position: relative;
      margin-top: 15px;
      margin-left: 20px;
      left: 50%;
      transform: translateX(-50%);
    }
    h1 {
      font-size: 28px;
      font-weight: 700;
      line-height: 140%; /* 39.2px */
      color: $black0;
      > em {
        color: #4b52ff;
      }
    }
  }
}
.container_error {
  padding: 235px 0 214px;
  position: relative;
  max-width: 430px;
  margin: 0 auto;
  color: #000;
  text-align: center;
  .txt_error {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
    padding: 10px 0 20px;
  }
  .btn_main {
    width: 200px;
    margin: 0 auto;
  }
  .img_block {
    position: absolute;
    &.img_block_1 {
      top: 699px;
      left: -490px;
    }
    &.img_block_2 {
      top: 385px;
      right: -505px;
    }
  }
}
@media (max-width: 999px) {
  .container_error {
    padding: 170px 0 166px;
    min-width: 360px;
    max-width: 360px;
    .txt_error {
      font-size: 18px;
      line-height: 1.5;
      padding: 16px 0 20px;
    }
    .btn_main {
      width: 180px;
    }
    .img_yeti {
      height: 223px;
    }
  }
}
</style>
